import React from 'react';
import { observer } from 'mobx-react';
import { modalStore } from 'apps/modals/app';

import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import { EditPhaseForm } from 'apps/project/views/editPhaseForm';

import {
  PhaseBadgeWrapper,
  BadgeStyled,
  ButtonWrapper,
} from 'apps/project/views/phaseBadge.styles';
import { themes } from 'styles/themes/wikifactoryNew';

export const PhaseBadge = observer((props: { project: any }) => {
  const clickStatus = () => {
    props.project.EditPhase();
    modalStore.SetModalComponent(EditPhaseForm, {
      projectApp: props.project,
    });
  };

  const {
    project: { phase, editing, name },
  } = props;

  return (
    <PhaseBadgeWrapper>
      {(phase || editing) && (
        <>
          <Tooltip id='tooltipBadge' delayShow={500} html={true} />
          <BadgeStyled
            data-testid='phase-badge'
            text={
              phase
                ? `${phase.name}${phase.order > 0 ? ' phase' : ''}`
                : 'No phase selected'
            }
            size='default'
            customBgColor={phase && phase.color}
            style={{ background: themes.color.wfGrey100 }}
            editing={editing}
            data-tip={
              phase && !editing
                ? `<strong>${name}</strong> is in the <strong>${phase.name} Phase</strong>.`
                : ''
            }
            data-for='tooltipBadge'
          />
        </>
      )}
      {editing && (
        <ButtonWrapper>
          <Button
            variant='secondary'
            icon='add'
            size='xsmall'
            ariaLabel='Set a Phase'
            onClick={clickStatus}
            outline
            data-testid='phase-add-icon'
          />
        </ButtonWrapper>
      )}
    </PhaseBadgeWrapper>
  );
});
